import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { getCarts, getCurrentCart, selectCart } from 'features/shoppingCart/shoppingCartSlice';
import { useThunkDispatch } from 'hooks/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 200,
    },
  }),
);

const CartSelection = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const currentCart = useSelector(getCurrentCart);
  const carts = useSelector(getCarts);

  const dispatch = useThunkDispatch();

  const handleCartChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    dispatch(selectCart(carts[Number(event.target.value)].cartId));
  };

  return (
    <FormControl>
      <InputLabel htmlFor="select-cart">{t('current_cart')}</InputLabel>
      <Select
        value={carts.map(cart => cart.cartId).indexOf(currentCart.cartId)}
        onChange={handleCartChange}
        inputProps={{
          name: 'Select Cart',
          id: 'select-cart',
        }}
        className={classes.formControl}
      >
        {carts.map((cart, index) => (
          <MenuItem value={index} key={`${cart.name}-${index}`}>
            {cart.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CartSelection;
